import { CompletePurchaseProps } from 'components/business/checkout/CompletePurchase';

/**
 * Public for testing
 * Grabs the effective purchase to utilize primarily for price calculations. If there are props passed
 * to the function, we utilized the passed props rather than the current props.
 *
 * IMPORTANT: This function must utilize passed props even if its calculated price is nullish,
 * as this function is utilized for change detection such as comparing previous props to current.
 *
 * Changing this behavior has caused incidents. See https://github.com/tocktix/admin/pull/28149 and https://github.com/tocktix/admin/pull/35330
 */
export const getEffectivePurchase = (
  passedProps: CompletePurchaseProps | undefined,
  currentProps: CompletePurchaseProps
) => {
  if (passedProps) {
    return passedProps.purchase.calculatedPrice;
  }

  return currentProps.purchase.calculatedPrice;
};
